import React from 'react';
import { Skeleton, SkeletonItem } from '@fluentui/react-components';
import { useSpaceCardSkeletonStyles } from './SpaceCardSkeleton.styles';

const AMENITY_CHIP_COUNT = 4;

export interface SpaceCardSkeletonProps {
  className?: string;
}

export const SpaceCardSkeleton: React.FC<SpaceCardSkeletonProps> = ({ className }) => {
  const styles = useSpaceCardSkeletonStyles();

  return (
    <Skeleton
      aria-hidden="true"
      data-testid="space-card-skeleton"
      {...(className ? { className } : {})}
    >
      <div className={styles.root}>
        <div className={styles.topRow}>
          <SkeletonItem className={styles.imageArea} data-testid="space-card-skeleton-image" />
          <div className={styles.contentSection}>
            <SkeletonItem className={styles.title} data-testid="space-card-skeleton-title" />
            <SkeletonItem className={styles.metadata} data-testid="space-card-skeleton-capacity" />
            <div className={styles.amenityRow} data-testid="space-card-skeleton-amenities">
              {Array.from({ length: AMENITY_CHIP_COUNT }, (_, i) => (
                <SkeletonItem key={i} className={styles.amenityChip} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </Skeleton>
  );
};

SpaceCardSkeleton.displayName = 'SpaceCardSkeleton';
